import { useRouteError } from 'react-router-dom'
import { Text, Title } from '@common/ui'

const ErrorPage = () => {
  // @ts-expect-error useRouteError() is typed as unknown
  const error: { statusCode?: number; statusText?: string; message?: string } = useRouteError()
  return error.statusCode === 404 ? (
    <Title order={4}>Page not found</Title>
  ) : (
    <div>
      <Title order={4}>Internal error</Title>
      <Text>An unexpected error has occurred: {error.statusText || error.message || 'Unknown error'}</Text>
    </div>
  )
}

export default ErrorPage
